






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FriendlyString extends Vue {
	@Prop() public value: string;
	@Prop({default: 'unknown'}) public placeholder: string;

	public get formattedValue() {
		if (this.isUnknown) {
			return this.placeholder;
		}

		return this.value;
	}

	public get isUnknown() {
		return !this.value || this.value.trim().length === 0;
	}
}
